module.exports = __webpack_public_path__ + "static/media/Bb6.0681743b.mp3";


//////////////////
// WEBPACK FOOTER
// ./node_modules/jazzband/demo/samples/piano/Bb6.mp3
// module id = 186
// module chunks = 0